export type PasswordRuleKey = 'minLength' | 'uppercase' | 'lowercase' | 'digit' | 'special';

export interface PasswordStrength {
  score: number;
  missingRules: PasswordRuleKey[];
  isValid: boolean;
}

const MIN_LENGTH = 12;

const CLASS_TESTS: Array<{ key: PasswordRuleKey; test: (password: string) => boolean }> = [
  { key: 'uppercase', test: (password) => /[A-Z]/.test(password) },
  { key: 'lowercase', test: (password) => /[a-z]/.test(password) },
  { key: 'digit', test: (password) => /\d/.test(password) },
  { key: 'special', test: (password) => /[^A-Za-z0-9]/.test(password) },
];

export const getPasswordStrength = (password: string): PasswordStrength => {
  const missingRules: PasswordRuleKey[] = [];

  if (password.length < MIN_LENGTH) {
    missingRules.push('minLength');
  }

  let score = 0;
  CLASS_TESTS.forEach(({ key, test }) => {
    if (test(password)) {
      if (password.length >= MIN_LENGTH) {
        score += 1;
      }
    } else {
      missingRules.push(key);
    }
  });

  return { score, missingRules, isValid: password.length >= MIN_LENGTH && score >= 3 };
};
